import { SortOrder } from '../constants'

const DEFAULT_REQUEST_BODY = `{
  "programkey": "Enphase Test",
  "siteIds": [12345, 98765],
  "performanceDateFrom": "2026-08-01",
  "performanceDateTo": "2026-08-31",
  "scoreLimit": 100.00
}`

const CSV_FILE_PREFIX = 'site_daily_performance'
const DRILL_CSV_PREFIX = 'performance'

const EMPTY_TABLE_TEXT = 'No data available. Enter filter criteria and click Fetch & Render.'

const FETCH_ERROR_MESSAGE = 'Failed to fetch site daily performance data'

const SCORE_THRESHOLDS = {
  GREAT: 90,
  GOOD: 70,
  WARN: 50,
}

const DRILL_HEADINGS = [
  { id: 'endAt', label: 'End At' },
  { id: 'dischargePower', label: 'ACT DSCH (W)' },
  { id: 'rateWatt', label: 'REQ RATE (W)' },
  { id: 'percentage', label: 'Perf %' },
  { id: 'soc', label: 'SoC %' },
  { id: 'targetSoc', label: 'Target SoC' },
]

export {
  SortOrder,
  DEFAULT_REQUEST_BODY,
  CSV_FILE_PREFIX,
  DRILL_CSV_PREFIX,
  EMPTY_TABLE_TEXT,
  FETCH_ERROR_MESSAGE,
  SCORE_THRESHOLDS,
  DRILL_HEADINGS,
}
